import { requester } from "App";
import P from "components/P";
import CustomButton from "components/buttons/CustomButton";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { decode } from "shared/utils/Utils";
import puffuIcon from "resources/img/puffu/puffuIcon.png";
import VerticalFlex from "layouts/flex/VerticalFlex";
import FlexChild from "layouts/flex/FlexChild";
import Container from "layouts/container/Container";
import Dummy from "components/Dummy";
import { CartReducer } from "shared/redux/reducers/shopping/CartReducer";
import { useDispatch } from "react-redux";


function PuffuOrderPaymentComplete() {
    const { id } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [data, setData] = useState();
    const [deviceCode, setDeviceCode] = useState();
    const [testState, setTestState] = useState("");
    useEffect(() => {
        const queryParams = new URLSearchParams(window.location.search);
        const dataParams = queryParams.get('data');
        const deviceCodeParams = queryParams.get('deviceCode');

        // 결과 출력


        // 디코딩된 문자열 확인
        const decodedString = decode(dataParams);

        setData(decodedString);
        setDeviceCode(deviceCodeParams);
        dispatch(CartReducer.actions.reset());

    }, []);
    useEffect(() => {
        // if (data) {

        //     const jsonArray = JSON.parse(data);

        //     // 변환된 결과를 담을 JSON 배열 생성
        //     const resultArray = [];

        //     // JSON 배열 순회
        //     for (let i = 0; i < jsonArray.length; i++) {
        //         // 현재 요소 가져오기
        //         const itemArray = jsonArray[i];

        //         // productCode와 quantity 추출
        //         const productCode = itemArray[0];
        //         const quantity = itemArray[1];

        //         // JSON 객체 생성 후 결과 배열에 추가
        //         const itemObject = {
        //             productCode: productCode,
        //             quantity: quantity
        //         };
        //         resultArray.push(itemObject);
        //     }

        //     // 결과 출력


        //     let machineData = {
        //         userId: "",
        //         code: "order",
        //         roomId: id,
        //         content: resultArray,
        //         deviceCode: deviceCode

        //     }

        //     requester.testOrder(machineData, (result) => {
        //         
        //     })
        // }
    }, [data])
    const onClick = () => {
        navigate(`/ws/${id}/mobile/scan`)

    }
    const btnStyle = {
        width: "90%",
        backgroundColor: "var(--main-color)",
        border: "none",
        height: "48px"
    }
    return (
        <Container height={"85vh"}>
            <VerticalFlex>
                <FlexChild justifyContent={"flex-end"}>
                    <img src={puffuIcon} />
                    <Dummy height={"15px"} />
                    <P size={"7vw"} font={"GmarketSansBold"} color={"var(--main-color)"}>선결제완료!</P>
                    <Dummy height={"15px"} />
                    <P size={18} weight={"bold"}>결제가 정상적으로 완료되었습니다.</P>
                </FlexChild>
                <FlexChild>
                    <P>{testState}</P>
                </FlexChild>
                {/* <FlexChild justifyContent={"flex-end"}>
                    <CustomButton style={btnStyle} onClick={onClick} text={"첫 화면으로 돌아가기"} />
                </FlexChild> */}
                <FlexChild justifyContent={"flex-end"}>
                    <CustomButton style={btnStyle} onClick={onClick} text={"돌아가기"} />
                </FlexChild>

            </VerticalFlex>
        </Container>
    );
}

export default PuffuOrderPaymentComplete;